import styled from "styled-components"
export const Container = styled.div`
    & p, * {
        color: ${props => props.theme.textColor};
    }
`